import { TextField } from '@mui/material'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { Controller } from 'react-hook-form'
import { PatternFormat } from 'react-number-format'

/**
 * @description Renders a phone number input field wrapped in a Controller component.
 *
 * @author Maria Eduarda Franke
 * @param {string} props.name - The name of the input field.
 * @param {string} props.label - The label for the input field.
 * @param {Object} props.control - The control object from react-hook-form.
 * @param {Object} props.errors - The errors object from react-hook-form.
 * @returns {JSX.Element} - The rendered text input field.
 */
const FormInputPhone = forwardRef(({ name, label, control, errors, ...props }, ref) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <PatternFormat
                    {...field}
                    ref={ref}
                    format='(##) # ####-####'
                    allowEmptyFormatting
                    mask='_'
                    customInput={TextField}
                    label={label}
                    error={!!errors}
                    helperText={errors?.message}
                    {...props}
                />
            )}
        />
    )
})

FormInputPhone.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object
}

FormInputPhone.displayName = 'FormInputPhone'

export default FormInputPhone